import React, { createContext, useContext, useReducer, useEffect } from 'react';
// Actions
import { list as logList } from '../actions/services';

const LogsContext = createContext();

const initialState = {
  data: {
    items: [],
    totalResults: 0,
  },
  loading: true,
  listViewMode: null,
  filters: {
    serviceType: null,
    servicePartner: null,
    serviceOrigin: null,
    worker: null,
  },
  pager: {
    page: 1,
    recordsPerPage: 10,
  },
};

const dataReducer = (state, action) => {
  switch (action.type) {
    case 'SET_DATA':
      return { ...state, data: action.payload, loading: false };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_LIST_VIEW_MODE':
      return { ...state, listViewMode: action.payload };
    case 'SET_FILTERS':
      return { ...state, filters: action.payload };
    case 'SET_PAGER':
      return { ...state, pager: action.payload };
    default:
      return state;
  }
};

export const LogsDataProvider = ({ children }) => {
  // useReducer
  const [state, dispatch] = useReducer(dataReducer, initialState);

  // useEffect
  useEffect(() => {
    dispatch({ type: 'SET_LOADING', payload: true });

    const fetchData = async () => {
      await logList({
        serviceTypeId: state.filters.serviceType,
        servicePartnerId: state.filters.servicePartner,
        serviceOriginId: state.filters.serviceOrigin,
        workerId: state.filters.worker,
        page: state.pager.page,
        recordsPerPage: state.pager.recordsPerPage,
        success: (data) => {
          dispatch({ type: 'SET_DATA', payload: data });
        },
        error: (error) => {
          throw new Error('Failed to fetch data');
        },
      });
    };

    fetchData();
  }, [state.pager, state.filters]);

  useEffect(
    () => {
      const storeView = localStorage.getItem('LogsListViewMode');

      dispatch({
        type: 'SET_LIST_VIEW_MODE',
        payload: storeView && parseInt(storeView) !== state.listViewMode ? parseInt(storeView) : 0,
      });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return <LogsContext.Provider value={{ state, dispatch }}>{children}</LogsContext.Provider>;
};

export const useLogsData = () => {
  const context = useContext(LogsContext);
  if (!context) {
    throw new Error('useLogsData must be used within a LogsDataProvider');
  }
  return context;
};
